<div class="modal fade " id='popUp-Config' tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true"
  data-backdrop="static" data-keyboard="false">

  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">

      <div class="modal-header justify-content-between">
        <h5 class="modal-title"> Configurações </h5>
        <img data-bs-dismiss="modal" class='bt-fechar' src="assets/img/icon_bt-limpar_header.svg" (click)="fecharConfigs()">
      </div>

      <div class="modal-body d-flex flex-column">
        <div class="d-flex flex-row">
          <p class="mb-4">Código de Instalação do Aplicativo do Motorista: </p> 
          <p class="ms-1 font-weight-bold">  {{ calculoCodigoAcesso() }} </p>
        </div>

        <div class="geral">
 
          <div class="d-flex">
            <label for="switchTelefone"class="slide-toggle ms-1">
              <input
                type="checkbox"
                [(ngModel)]="exibirTelefone" 
                (change)="alterarConfig(exibirTelefone,'ExibirTelefoneVendedorAPP')"
                id="switchTelefone"
              />
              <span style="margin-bottom: -1px;"></span>
            </label>
            <p  class="ms-2 mb-4">Exibir telefone do vendedor no Aplicativo</p>
          </div>

          <div class="d-flex">
            <label for="switchTelefoneCliente"class="slide-toggle ms-1">
              <input
                type="checkbox"
                [(ngModel)]="exibirTelefoneCliente" 
                (change)="alterarConfig(exibirTelefoneCliente,'ExibirTelefoneClienteAPP')"
                id="switchTelefoneCliente"
              />
              <span style="margin-bottom: -1px;"></span>
            </label>
            <p  class="ms-2 mb-4">Exibir telefone do cliente no Aplicativo</p>
          </div>

          <div class="d-flex">
            <label for="switchFinalizarRoteiroAntesProx"class="slide-toggle ms-1" style="margin-top: -12px;">
              <input
                type="checkbox"
                [(ngModel)]="obrigaFinalizarRoteiroAntes" 
                (change)="alterarConfig(obrigaFinalizarRoteiroAntes,'FinalizarRoteiroAntesIniciarProx')"
                id="switchFinalizarRoteiroAntesProx"
              />
              <span style="margin-bottom: -1px;"></span>
            </label>
            <p  class="ms-2 mb-4">Na tela de seleção de roteiros, exigir o encerramento do roteiro atual antes de iniciar um novo</p>
          </div>

          <div class="d-flex">
            <label for="switchBloquearMotoristaVersaoDesatualizada" class="slide-toggle ms-1">
              <input
                type="checkbox"
                [(ngModel)]="bloquearMotoristaVersaoDesatualizada" 
                (change)="alterarConfig(bloquearMotoristaVersaoDesatualizada,'BloquearMotoristaVersaoDesatualizada')"
                id="switchBloquearMotoristaVersaoDesatualizada"
              />
              <span style="margin-bottom: -1px;"></span>
            </label>
            <p class="ms-2 mb-4">Bloquear motorista com versão desatualizada</p>
          </div>

          <div class="mb-3">
            <p class="mb-1 font-weight-bold" > Tempo de atualização da página</p>
            <select class="form-control" (ngModelChange)="onChangeTempoAtualizacao($event)" [(ngModel)]="tempoAtualizacao">
              <option *ngFor="let horario of horariosAtualizacoes" [ngValue]="horario">{{ horario.descricao }}</option>
            </select>
          </div>
        </div>
        
        <div class="cards">
          <p class="mb-1 font-weight-bold">Cards</p>
          <button class="mb-4 btn-redefinir-config" (click)="onResetarPosicoesClick()" >Redefinir configuração cards</button>
          
        </div>
       

        <!-- Alertas -->
        <p class="mb-2 font-weight-bold">Definições de alertas</p>
        <div *ngFor="let alerta of alertas">
          <label [for]="alerta.AlertaPainelID" class="slide-toggle ms-1 mt-2" (change)="updateAlerta(alerta)">
            <input
              type="checkbox"
              [(ngModel)]="alerta.Ativo" 
              [id]="alerta.AlertaPainelID"
            />
            <span style="margin-bottom: -1px;"></span>
          </label>
          <p  class="ms-2 mb-1 d-inline-flex">{{ alerta.TipoAlerta == 'Tempo de descarga'? 'Tolerância de tempo de descarga' : alerta.TipoAlerta   }}</p>
          <select class="form-control mb-4 d-block" style="width: 240px;"  *ngIf="alerta.mostraSelect" [disabled]="!alerta.Ativo" (change)="atualizarValorAlerta($event.target.value, alerta)" >
            <option *ngFor="let option of alerta.options" [selected]="alerta.Valor == option" > {{ option }}{{ alerta.descricao }}</option>   
          </select>         
        </div>


        <!-- Nav tabs -->
        

            
          <div class="tab-pane conteudo" id="config-icones" role="tabpanel">
            <div class='container'>
            <popup-icones *ngIf="controlStatus.popupConfig"></popup-icones>
            </div>
          </div>
      </div>

      <div class="modal-footer">
        <button data-bs-dismiss="modal" class="btn-salvar" (click)="fecharConfigs()"><i class="fa fa-check me-2"></i> Salvar</button>
      </div>
    </div>
  </div>
  